export default "__VITE_ASSET__CMXNUUsm__"